import { createSlice } from '@reduxjs/toolkit'
import * as DynaMakerContract from '../../integration/DynamakerContract'

interface SelectedItemState {
  selectedItem: DynaMakerContract.Item
  slotOptions: any[] | null
}

const initialState: SelectedItemState = {
  selectedItem: {
    id: '',
    item: 'assembly',
    props: {},
  },
  slotOptions: null, // []
}

const selectedItemSlice = createSlice({
  name: 'selectedItem',
  initialState,
  reducers: {
    handleSelectedItem(state, action) {
      const selectedItem = action.payload

      state.selectedItem = selectedItem
    },
    handleSlotOptions(state, action) {
      const { slotOptions, _dmEvent } = action.payload

      if (!slotOptions || slotOptions.length === 0) {
        console.warn(`Unexpected value ${slotOptions} for slotOptions in handleSlotOptions reducer`)
      }

      if (_dmEvent === 'configuration-update' && state.selectedItem.item && state.selectedItem.item !== 'assembly') {
        return
      }

      if (JSON.stringify(state.slotOptions) !== JSON.stringify(slotOptions)) {
        state.slotOptions = slotOptions || null
      }
    },
  },
})

export const { handleSelectedItem, handleSlotOptions } = selectedItemSlice.actions

export default selectedItemSlice.reducer
